/**
 * The build-time prerender bakes a page's data into the HTML as a JSON script
 * tag, and the client reads it back on mount instead of refetching. The API
 * writes the same tag at request time for blog posts published since the last
 * deploy, so both paths have to agree on the id and the escaping — hence this
 * module rather than a copy on each side.
 */
export const PRERENDER_DATA_SCRIPT_ID = '__PRERENDER_DATA__';
/**
 * JSON destined for a `<script>` body must not be able to close that tag or
 * open a comment. Escaping `<`, `>`, and `&` keeps the JSON valid while making
 * `</script>` inside a post title inert; the two line separators are escaped
 * because they're valid in JSON strings but not in JavaScript source.
 */
export function serializeJsonForScript(value) {
    return JSON.stringify(value)
        .replace(/</g, '\\u003c')
        .replace(/>/g, '\\u003e')
        .replace(/&/g, '\\u0026')
        .replace(/\u2028/g, '\\u2028')
        .replace(/\u2029/g, '\\u2029');
}
/** Append the page's data to `html`, just before `</body>`. */
export function injectPrerenderData(html, data) {
    return html.replace('</body>', `<script id="${PRERENDER_DATA_SCRIPT_ID}" type="application/json">${serializeJsonForScript(data)}</script></body>`);
}
